import React, { useEffect, useState, useContext } from 'react';
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import { Context } from 'context/AuthContext';
import { GET_LIST_AVISO } from 'services/Aviso';
import { COUNT_PENDENCIA_USUARIO_ATUAL } from 'services/Pendencia';
import { COUNT_RASCUNHO_USUARIO_ATUAL } from 'services/Rascunho';

import rascunho from 'assets/imgs/icons/rascunho.png';
import pendencias from 'assets/imgs/icons/pendencias.png';
import onoff from 'assets/imgs/icons/plano_midias_on_off.png';
import atendimento from 'assets/imgs/icons/atendimento_ao_usuario.png';
import consultar from 'assets/imgs/icons/consultar.png';
import materiais from 'assets/imgs/icons/icon_materiais.svg';
import histpedidos from 'assets/imgs/icons/icon_histpedidos.svg';

import './styles.scss';

const ContentHome = () => {
  const [warnings, setWarnings] = useState([]);
  const { showLoader } = useContext(Context);
  const [corPendencia, setCorPendencia] = useState([]);
  const [corRascunho, setCorRascunho] = useState([]);

  useEffect(() => {
    async function fetchData() {
      showLoader(true);

      const corPendenciaResult = await COUNT_PENDENCIA_USUARIO_ATUAL();
      setCorPendencia(corPendenciaResult.value);

      const countUsuarioAtual = await COUNT_RASCUNHO_USUARIO_ATUAL();
      setCorRascunho(countUsuarioAtual.value);

      const warningsResult = await GET_LIST_AVISO();
      setWarnings(warningsResult.value);

      showLoader(false);
    }
    fetchData();
  }, []);

  return (
    <>
      <div className="wrapper-choose-the-costumer flex-fill">
        <div className="warnings">
          <Carousel>
            {warnings?.map((item) => {
              return (
                <Carousel.Item key={item.avisoId}>
                  {item.urlRedirecionamento ? (
                    <a
                      href={item.urlRedirecionamento}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="d-block w-100"
                        src={item.urlImagem}
                        alt={item.texto}
                      />
                    </a>
                  ) : (
                    <img
                      className="d-block w-100"
                      src={item.urlImagem}
                      alt={item.texto}
                    />
                  )}
                </Carousel.Item>
              );
            })}
          </Carousel>
        </div>
        {/* <div className="actions"> */}
        <div className="actions">
          <div>
            <Link to="/pedido-materiais">
              <div>
                <div className="button-content">
                  <div>
                    <img src={materiais} alt="pedido-materiais" />
                  </div>
                  <div className="btn-divider" />
                  <div>Materiais Personalizados</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    Solicite artes personalizadas com qualquer layout, produto
                    ou dimensões necessárias.
                  </p>
                </div>
              </div>
            </Link>

            <Link to="/historico-pedidos">
              <div>
                <div className="button-content">
                  <div>
                    <img src={histpedidos} alt="Historico pedido" />
                  </div>
                  <div className="btn-divider" />
                  <div>Histórico de pedidos</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    Histórico de seus pedidos feitos caso queira reaproveitá-los
                    para solicitar novamente
                  </p>
                </div>
              </div>
            </Link>
          </div>

          <div>
            <Link to="/pendencias">
              <div style={{ backgroundColor: corPendencia > 0 ? 'red' : '' }}>
                <div className="button-content">
                  <div>
                    <img src={pendencias} alt="pendencias" />
                  </div>
                  <div className="btn-divider" />
                  <div>Pendências</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    Solicitações pendentes de alguma ação (aprovação /
                    reprovação)
                  </p>
                </div>
              </div>
            </Link>
            <Link to="/rascunho">
              <div style={{ backgroundColor: corRascunho > 0 ? 'red' : '' }}>
                <div className="button-content">
                  <div>
                    <img src={rascunho} alt="Rascunhos" />
                  </div>
                  <div className="btn-divider" style={{ marginLeft: '10px' }} />
                  <div>Rascunhos</div>
                </div>
                <div className="button-content-hover">
                  <p>Rascunhos de solicitações não enviadas.</p>
                </div>
              </div>
            </Link>
          </div>

          <div>
            <Link to="/banco-de-imagens">
              <div>
                <div className="button-content">
                  <div>
                    <img src={onoff} alt="Consultar" />
                  </div>
                  <div className="btn-divider" />
                  <div>Banco de imagens</div>
                </div>
                <div className="button-content-hover">
                  <p>Banco de Imagens de Produtos para download (mockups).</p>
                </div>
              </div>
            </Link>
            <Link to="/banco-de-artes">
              <div>
                <div className="button-content">
                  <div>
                    <img src={rascunho} alt="Consultar" />
                  </div>
                  <div className="btn-divider" />
                  <div>Banco de artes</div>
                </div>
                <div className="button-content-hover">
                  <p>Banco de Artes já feitas na plataforma.</p>
                </div>
              </div>
            </Link>
          </div>
          <div>
            <Link to="/consulta">
              <div>
                <div className="button-content">
                  <div>
                    <img src={consultar} alt="Consultar" />
                  </div>
                  <div className="btn-divider" />
                  <div>Consultar</div>
                </div>
                <div className="button-content-hover">
                  <p>Consulta de solicitações realizadas no sistema.</p>
                </div>
              </div>
            </Link>

            <Link to="/atendimento">
              <div>
                <div className="button-content">
                  <div>
                    <img src={atendimento} alt="Atendimento" />
                  </div>
                  <div className="btn-divider" />
                  <div>Atendimento</div>
                </div>
                <div className="button-content-hover">
                  <p>Alguma dúvida? entre em contato conosco.</p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center text-center mb-3">
        <h5 className="text-primary font-weight-bold home-horario-atendimento">
          Em caso de dúvidas ou ocorrências sobre o Encartes Vigor, ligar para
          (11) 98962-7262 de segunda a sexta no horário das 9:00 às 18:00 ou,
          clique em atendimento ao usuário e abra um chamado que entraremos em
          contato.
        </h5>
      </div>
    </>
  );
};

const App = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentHome />
      <Bottom />
    </div>
  );
};

export default App;
